import { createSelector } from "reselect";

const getContent = state => state.content;

export const getContentData = createSelector(
  getContent,
  content => content.data || {},
);

export const hasContent = createSelector(
  getContent,
  content => content.data !== null,
);

export const getDefaultImageUrl = createSelector(
  getContentData,
  data => data.defaultVehicleImageUrl || null,
);

export const getRatingMeta = createSelector(
  getContentData,
  data => {
    const reviews = data.reviews || {};
    const ratingLogoUrl = reviews.ratingLogoUrl;
    const noRatingMessage = reviews.noRatingMessage || "No rating available";
    const ratingLogoAlt = reviews.ratingLogoAltText || "Rating logo";
    return {
      ratingLogoUrl,
      ratingLogoAlt,
      noRatingMessage,
    };
  },
);

export const getCalculationParametersContent = createSelector(
  getContentData,
  data =>
    data.calculationParameters ||
    `Term <strong>{duration}</strong> months and <strong>{annualMileage}</strong> miles pa`,
);

export const getShortlistModals = createSelector(
  getContentData,
  data => (data.shortlist ? loadModalData(data.shortlist) : {}),
);

const loadModalData = (shortlist) => {
  const modalData = [];
  shortlist.modals.map(item => {        
    modalData.push(item);
  })
  return modalData;
};

export const getProsConsHeading = createSelector(
  getContentData,
  data => (data.reviews && data.reviews.prosConsTitle) || null,
);

export const getNoSearchResultsContent = createSelector(
  getContentData,
  data => data.noSearchResults || {},
);

export const hasSorting = createSelector(
  getContentData,
  data => data.sorting,
);

export const getSorting = createSelector(
  getContentData,
  data => data.sorting || {},
);

export const getPageTitleFormat = createSelector(
  getContentData,
  data => data.pageTitleFormat,
);

export const getPageHeadings = createSelector(
  getContentData,
  data => {
    const templates = data.searchResultsHeadings || [{ format: "Search results" }];

    const parsedTemplates = templates.map(template => {
      const matches = template.format.match(/\{\w+\}/g) || [];
      const tokens = matches.map(m => m.replace("{", "").replace("}", ""));
      return {
        ...template,
        tokens,
      };
    });

    return parsedTemplates;
  },
);

export const getModelSummaryHeadingTemplate = createSelector(
  getContentData,
  data => data.modelSummaryHeading || "{make} {model}",
);

export const getFiltersByPageLevel = createSelector(
  getContentData,
  data =>
    data.filtersByPageLevel || {
      derivative: ["model"],
      model: ["range"],
    },
);
